import { memo } from 'react';
import WithDriverIconPopup from '../WithDriverIconPopup';

function DriverArrivedAtStopMarker({ backgroundColor, borderColor }) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_3950_621)">
        <path
          d="M28 12C28 5.37258 22.6274 0 16 0C9.37258 0 4 5.37258 4 12C4 18.6274 9.37258 24 16 24C22.6274 24 28 18.6274 28 12Z"
          fill={backgroundColor}
        />
        <path
          d="M16 1C22.07 1 27 5.93 27 12C27 18.07 22.07 23 16 23C9.93 23 5 18.07 5 12C5 5.93 9.93 1 16 1ZM16 0C9.37 0 4 5.37 4 12C4 18.63 9.37 24 16 24C22.63 24 28 18.63 28 12C28 5.37 22.63 0 16 0Z"
          fill={borderColor}
          fillOpacity="0.87"
        />
        <path
          d="M16 4.5C13.1 4.5 10.75 6.85 10.75 9.75C10.75 13.69 16 19.5 16 19.5C16 19.5 21.25 13.69 21.25 9.75C21.25 6.85 18.9 4.5 16 4.5ZM16 11.62C14.96 11.62 14.12 10.78 14.12 9.74C14.12 8.7 14.96 7.86 16 7.86C17.04 7.86 17.88 8.7 17.88 9.74C17.88 10.78 17.04 11.62 16 11.62Z"
          fill={borderColor}
          fillOpacity="0.87"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_3950_621"
          x="0"
          y="0"
          width="32"
          height="32"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity ="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3950_621" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3950_621"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export default WithDriverIconPopup(memo(DriverArrivedAtStopMarker));
